import dayjs from 'dayjs';

import { LastLogin } from '../../../api/types';

export const formatLastLoginDate = (lastLogin: NonNullable<LastLogin>) => {
    return lastLogin.at ? dayjs(lastLogin.at).format('HH:mm | DD MMM') : '-';
};
